export default function degreeDistanceForce(base = 300) {
  let nodes;
  let links;
  let neighbors;

  function rebuildNeighbors() {
    neighbors = new Map();
    if (!nodes || !links) return;
    for (const l of links) {
      const s = typeof l.source === 'object' ? l.source : nodes[l.source];
      const t = typeof l.target === 'object' ? l.target : nodes[l.target];
      if (!s || !t) continue;
      if (s.community !== t.community) continue;
      if (!neighbors.has(s)) neighbors.set(s, []);
      if (!neighbors.has(t)) neighbors.set(t, []);
      neighbors.get(s).push(t);
      neighbors.get(t).push(s);
    }
  }

  function force(alpha) {
    if (!nodes || !neighbors) return;
    for (const n of nodes) {
      if (!n) continue;
      if (n.virtual) continue;
      const vn = n.virtualNode;
      if (vn && vn.mainNode === n) continue;
      const adj = neighbors.get(n);
      if (!adj || adj.length === 0) continue;
      let best = adj[0];
      let bestLevel = best.hierLevel ?? 0;
      for (const nb of adj) {
        const lvl = nb.hierLevel ?? 0;
        if (lvl < bestLevel) {
          best = nb;
          bestLevel = lvl;
        }
      }
      const levelN = n.hierLevel ?? 0;
      if (levelN <= bestLevel) continue;
      const desired = base * (levelN - bestLevel + 1);
      let dx = (n.x || 0) - (best.x || 0);
      let dy = (n.y || 0) - (best.y || 0);
      let dist = Math.sqrt(dx * dx + dy * dy);
      if (!dist) continue;
      if (dist === desired) continue;
      let f = ((dist - desired) / dist) * alpha;
      const fx = dx * f;
      const fy = dy * f;
      n.vx -= fx;
      n.vy -= fy;
    }
  }

  force.initialize = function (_) {
    nodes = _;
    rebuildNeighbors();
  };

  force.links = function (_) {
    if (!arguments.length) return links;
    links = _;
    rebuildNeighbors();
    return force;
  };

  force.distance = function (_) {
    return arguments.length ? ((base = +_), force) : base;
  };

  return force;
}
